import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { DisplayMode } from '@api-consent/types/common.js';
import { LitElementExtended } from '@src/classes/LitElementExtended.js';
import { features as featureDef } from '@src/defs/features.js';
import { store } from '@src/store/index.js';
import { ConsentType } from '@src/types/common.js';

@customElement('tef-coms-consent')
export class TefComsConsent extends connect(store)(LitElementExtended) {
  @property({ type: Object }) consent?: ConsentType = undefined;
  @property({ type: Boolean }) required: boolean = false;
  @property({ type: String }) layout: string = 'default';
  @property({ type: String }) mode: string = '';
  // @ts-expect-error: TODO -- remove this when we have a better solution for this
  @property({ type: String }) displayMode: DisplayMode = undefined;

  @state() generation: number = 1;

  connectedCallback(): void {
    super.connectedCallback();
    const { consents: { generation } } = store.getState();
    this.generation = generation!;
  }

  createRenderRoot() {
    return this; // no shadow DOM for sub-components
  }

  updated() {
    this.replaceElements();
  }

  get features() {
    const { id } = this.consent!;
    const existedFeatures = featureDef.filter((feature) => this.consent![feature]);

    if (existedFeatures.length < 1) {
      return null;
    }

    const disabled = !!this.mode.includes('multiedit');

    const featuresTemplate = this.getTemplateFn('featuresTemplate');
    return featuresTemplate(this.consent, disabled, id);
  }

  get consentblock() {
    const disabled = !!this.mode.includes('multiedit');
    const consentClasses = ['form-row'];
    const checkboxClasses = ['form-group-checkbox'];

    if (disabled) {
      consentClasses.push('coms-features');
    } else if (this.layout === 'group') {
      consentClasses.push('form-row--group');
      checkboxClasses.push('form-group-checkbox--size-small');
    }

    const consentTemplate = this.getTemplateFn('consentTemplate');
    return consentTemplate(consentClasses, checkboxClasses, this.consent, disabled, this);
  }

  render() {
    const { scope } = this.consent as ConsentType;

    if (this.required) {
      return unsafeHTML(scope);
    }

    return this.consentblock;
  }
}
